<template>
  <div class="simple-card" style="background-color: #F8F8F8">
    <div>
      <i :class="icon" :style="'font-size: 40px; height: 100%; padding: 12px; color:' + iconColor + '!important'"></i>
    </div>
    <div class="info-card-content">
      <h3 class="simple-card-title" style="margin: 0 0 7px 0 !important;">{{title}}</h3>
      <span v-if="previous" style="font-size: 27px; font-weight: bold; color: #3a3a3a; margin: 0px;">{{ previous}} <i class="fa fa-arrow-right" ></i></span>
      <span style="font-size: 27px; font-weight: bold; color: #3a3a3a; margin: 10px 10px 10px 0">{{ value }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'info-card',
  props: ['color', 'icon', 'title', 'iconColor', 'value', 'previous']
}

</script>

<style scoped lang="scss">
@import '../../../assets/k6styles/cards';

.simple-card {
  display: flex;
  justify-content: space-between;
  padding: 17px 15px 13px 15px;
}

.simple-card-title {
  font-size: 16px;
  font-weight: 300;
  color: #5e5e5e;
}
.info-card-content {
  text-align: right;
}

</style>


// WEBPACK FOOTER //
// InfoCard.vue?303cb812